import { GitBranch, Pen, Trash } from "lucide-react";
import React from "react";
import CommonDropdownMenu from "@/shared/components/ui/DropDown/DropdownMenu";
import { getDurationInfo } from "@/shared/utils/helperFunctions";

const ConditionCard = ({ condition, onEdit, onDelete }) => {
  const conditionLabel = condition?.conditions || "";
  const durationInfo = getDurationInfo(condition?.duration);

  const ConditionOptions = [
    {
      id: "Edit",
      name: "Edit",
      icon: <Pen size={16} />,
      onClick: () => {
        onEdit?.({ item: condition, variant: "condition" });
      },
    },
    {
      id: "Delete",
      name: "Delete",
      icon: <Trash size={16} color="#F04438" />,
      onClick: () => {
        onDelete?.({ item: condition, variant: "condition" });
      },
    },
  ];

  return (
    <div className="px-4 py-3.5 rounded-lg border border-secondary dark:border-secondary w-fit flex gap-2 items-center bg-white dark:bg-gray-900">
      <p className="text-xs font-semibold text-gray-800 dark:text-gray-100">Condition</p>
      <div className="w-[1px] h-5 bg-gray-200 dark:bg-gray-700" />
      <GitBranch size={18} className="text-secondary" />
      <p className="text-xs font-bold text-secondary">
        {conditionLabel}{" "}
        <>
          <span className="text-gray-800 dark:text-gray-200 font-medium">with in</span>{" "}
          {durationInfo?.label}
        </>
      </p>
      <CommonDropdownMenu actions={ConditionOptions} itemId={condition?.id} />
    </div>
  );
};

export default ConditionCard;
